<template>
    <div class="pb-4 text-a-brown-502314 border-b border-a-brown-d7c7b8">
        <div class="text-14 lg:text-16 pb-4 font-bold">{{ lbl.subscription.subscription_summary.subscription_type }}</div>
        <div class="flex lg:pr-3" v-if="subScriptPackage?.DisableOneTime == false">
            <img class="ml-0 mr-2 my-auto" v-show="selectType == 'Onetime'" src="@/assets/icon/ic-radio-active-red.svg" />
            <img class="ml-0 mr-2 my-auto cursor-pointer" @click="selectSubscription('Onetime')"  v-show="selectType != 'Onetime'" src="@/assets/icon/ic-radio-inactive-red.svg" />
            <div class="text-14 lg:text-16 ml-0 mr-auto my-auto">
                {{ lbl.subscription.subscription_summary.one_time }}
            </div>
        </div>
        <div class="text-12 text-a-brown-9f8273 pl-6 pb-4" v-if="subScriptPackage?.DisableOneTime == false">{{ lbl.subscription.subscription_summary.condition_one_time }}</div>
        <div class="flex lg:pr-3" v-if="subScriptPackage?.DisableRecursive == false">
            <img class="ml-0 mr-2 my-auto" v-show="selectType == 'Recurring'" src="@/assets/icon/ic-radio-active-red.svg" />
            <img class="ml-0 mr-2 my-auto cursor-pointer" @click="selectSubscription('Recurring')"  v-show="selectType != 'Recurring'" src="@/assets/icon/ic-radio-inactive-red.svg" />
            <div class="text-14 lg:text-16 ml-0 mr-auto my-auto">
                {{ lbl.subscription.subscription_summary.recurring }}
            </div>
        </div>
        <div class="text-12 text-a-brown-9f8273 pl-6 pb-4" v-if="subScriptPackage?.DisableRecursive == false">{{ FilterStringFormat(lbl.subscription.subscription_summary.condition_recurring, period) }}</div>
    </div>
</template>
<script>
//mixins
import LocaleMixin from "@/mixin/LocaleMixin.js";
import BKSubscription from '@/module/Subscription/List/service/BKSubscription';

export default {
    name: "SubscriptType",
    inject: ['PlaceOrderStore'],
    mixins: [LocaleMixin],
    data: function() {
        return {
            selectType: 'Onetime',
            subScriptPackage: null,
            period: null,
        };
    },
    created: async function() {
        // this.selectType = this.PlaceOrderStore.state.placeOrder.type;
        await this.getPackagesItem();
        if (this.subScriptPackage?.Period) {
            this.getPeriod();
        }
        if (this.subScriptPackage?.DisableOneTime == false) {
            this.selectSubscription('Onetime');
        } else if (this.subScriptPackage?.DisableRecursive == false) {
            this.selectSubscription('Recurring');
        }
    },
    methods: {
        selectSubscription: function(subscriptionType) {
            this.selectType = subscriptionType;
            this.PlaceOrderStore.state.placeOrder.type = subscriptionType;
            this.$emit('onSelect');
        },
        getPackagesItem: function () {
            let campaignId = this.$route.params.campaignId;
            return new Promise((resolve) => {
                this.isLoading = true;
                BKSubscription.apiGetMyPackagesItem(campaignId).subscribe({
                    next: (res) => {
                        this.subScriptPackage = res.data;
                        resolve();
                    },
                    error: (err) => {
                        console.log(err);
                        resolve();
                    }
                });
            });
        },
        getPeriod: function () {
            switch (this.subScriptPackage.Period) {
                case 'day':
                    this.period = this.subScriptPackage.Every + ' ' + this.lbl.subscription.subscription_summary.period.day;
                    break;
                case 'month':
                    this.period = this.subScriptPackage.Every + ' ' + this.lbl.subscription.subscription_summary.period.month;
                    break;
                case 'year':
                    this.period = this.subScriptPackage.Every + ' ' + this.lbl.subscription.subscription_summary.period.year;
                    break;
                default:
                    break;
            }
        }
    }
}
</script>